'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider.state('swagger', {
      url: '/swagger?name',
      template: '<swagger></swagger>'
    });

  $stateProvider.state('swaggerOAuthDone', {
      url: '/swaggerOAuthDone?code',
      template: '<swagger></swagger>'
    });
}


// WEBPACK FOOTER //
// ./client/app/swagger/swagger.routes.js